import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReservationService} from '../../trip-reservations/reservations.service';
import {GridOptions} from 'ag-grid';
import {constant} from '../../../app.constants';
import { modalSwal } from 'app/utils/helpers';


@Component({
  selector: 'app-previous-address',
  templateUrl: './previous-address.component.html',
  styleUrls: ['./previous-address.component.scss']
})
export class PreviousAddressComponent implements OnInit {

  @Input() riderId: any;
  @Output() onSelect?: EventEmitter<any> = new EventEmitter<any>();
  private gridAddresses: GridOptions;
  private gridApi;
  private gridColumnApi;

  constructor(protected _service: ReservationService) {
    const self = this;
    this.gridAddresses = <GridOptions>{
      enableSorting: true,
      enableColResize : true,
      sortingOrder: ['desc', 'asc', null]
    };
    this.gridAddresses.columnDefs = [

      {headerName: 'Loc. Type', field: 'modifierdescription', width: 110},
      {headerName: 'Address', field: 'streetaddress', width: 150},
      {headerName: 'Apt/Ste/Rm', field: 'roomaptnumber', width: 90},
      {headerName: 'City', field: 'city', width: 90},
      {headerName: 'Count', field: 'county', width: 90},
      {headerName: 'State', field: 'state', width: 90},
      {headerName: 'Zip Code', field: 'zip', width: 90},
      {headerName: 'Lat', field: 'latitude', width: 90},
      {headerName: 'Log', field: 'longitude', width: 90}
    ];
    this.gridAddresses.onGridReady     = function () {
      // self.gridAddresses.api.sizeColumnsToFit();
    };
  }

  ngOnInit() {
    this.loadPreviousAddresses(this.riderId);
  }

  private Loc_Type(row) {
    if (row.data.modifier) {
      return row.data.modifierdescription;
    }else {
      return '-';
    }
  }

  OnCellDoubleClicked($event) {
    if ($event.data !== null) {
      this.onSelect.emit($event.data);
    }
  }

  loadPreviousAddresses(riderId: number) {
    this._service.getData(constant.URL_GET_PREVIOUS_ADDRESSES + '/' + riderId).subscribe(
      data => {
        if (this.gridAddresses) {
          if (this.gridAddresses.api) {
            this.gridAddresses.api.setRowData(data);
          }
        }
      },
      error => modalSwal('Error', 'error', error.message)
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/previous-address/previous-address.component.ts